import { CustomerService } from "../_services/api/customers/customer.service";

export const defaultCustomerSettings = {
  namespaced: true,
  state: {
    id: undefined,
    settings: {
      CustomerCurrency: null
    },
  },
  actions: {
    async setCustomerById({ commit }, id) {
      return await CustomerService.getByCode(id, ["Code", "CurrencyCode"]).then(
        async (result) => {
          if (result.data.value.length > 0) {
            commit("setCustomerCurrency", result.data.value[0].CurrencyCode);
          }
        }
      );
    },
    setCustomerCode({ commit }, message) {
      commit("setCustomerCode", message)
    },
    setCustomerCurrencyCode({ commit }, message) {
      commit("setCustomerCurrency", message);

    }
  },
  mutations: {
    setCustomerCode(state, customerCode) {
      state.id = customerCode;
    },
    setCustomerCurrency(state, customerCurrency) {
      state.settings.CustomerCurrency = customerCurrency;
    },
  },
  getters: {
    getSettings: (state) => () => {
      return state.settings;
    },

    getCustomerCode: (state) => () => {
      return state.id;
    },
  },
};
